var _circle, _circle2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.3307,
    cy: 22.4593,
    r: 22.3304,
    fill: "url(#paint0_linear_1_13982)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.3307,
    cy: 22.4593,
    r: 22.3304,
    fill: "#FFF2E3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_13982)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_13982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1144 34.8371C28.4929 34.8371 28.8104 34.7088 29.0669 34.4523C29.3234 34.1958 29.4512 33.8788 29.4503 33.5012C29.4494 33.1236 29.3211 32.8066 29.0655 32.5501C28.81 32.2936 28.4929 32.1653 28.1144 32.1653C27.7359 32.1653 27.4189 32.2936 27.1633 32.5501C26.9077 32.8066 26.7795 33.1236 26.7786 33.5012C26.7777 33.8788 26.9059 34.1963 27.1633 34.4537C27.4207 34.711 27.7377 34.8388 28.1144 34.8371ZM28.1144 29.4936C28.4929 29.4936 28.8104 29.3654 29.0669 29.1089C29.3234 28.8524 29.4512 28.5354 29.4503 28.1578V22.8144C29.4503 22.4359 29.322 22.1188 29.0655 21.8632C28.8091 21.6077 28.492 21.4794 28.1144 21.4785C27.7368 21.4776 27.4198 21.6059 27.1633 21.8632C26.9068 22.1206 26.7786 22.4377 26.7786 22.8144V28.1578C26.7786 28.5363 26.9068 28.8538 27.1633 29.1103C27.4198 29.3667 27.7368 29.4945 28.1144 29.4936Z",
    fill: "#FEA362"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8654 11.2824C21.4333 10.9264 23.0589 10.9068 24.635 11.2248C26.2111 11.5428 27.702 12.1913 29.0093 13.1275C30.3166 14.0637 31.4108 15.2664 32.2197 16.6562C33.0286 18.0461 33.5338 19.5917 33.7021 21.1911C33.7317 21.4726 33.6483 21.7543 33.4703 21.9743C33.2922 22.1943 33.034 22.3346 32.7526 22.3642C32.4712 22.3938 32.1895 22.3104 31.9695 22.1323C31.7496 21.9542 31.6094 21.696 31.5797 21.4145C31.3969 19.6766 30.7255 18.0262 29.6435 16.6543C28.5614 15.2824 27.1129 14.2452 25.4658 13.6628C23.8187 13.0804 22.0403 12.9767 20.3366 13.3637C18.633 13.7507 17.0738 14.6125 15.8397 15.8493C14.6056 17.0861 13.747 18.6474 13.3635 20.3521C12.98 22.0569 13.0871 23.8355 13.6726 25.4819C14.2581 27.1283 15.2979 28.5751 16.6716 29.6547C18.0453 30.7343 19.6966 31.4026 21.4344 31.5821C21.5748 31.5952 21.7112 31.636 21.8357 31.7021C21.9602 31.7682 22.0704 31.8584 22.1599 31.9674C22.2494 32.0764 22.3164 32.202 22.357 32.3371C22.3976 32.4721 22.4111 32.6139 22.3966 32.7542C22.3821 32.8944 22.34 33.0305 22.2727 33.1544C22.2053 33.2782 22.1141 33.3876 22.0042 33.476C21.8944 33.5644 21.7681 33.6301 21.6327 33.6695C21.4973 33.7088 21.3554 33.7208 21.2153 33.705C18.531 33.4287 16.0321 32.2073 14.1647 30.2587C12.2973 28.3101 11.183 25.7612 11.0206 23.0669C10.8583 20.3726 11.6584 17.7083 13.2782 15.5494C14.8981 13.3906 17.2322 11.8778 19.864 11.281L19.8654 11.2824ZM22.3846 15.2678C22.6676 15.2678 22.939 15.3802 23.139 15.5803C23.3391 15.7805 23.4515 16.0519 23.4515 16.3349V23.8048H17.7615C17.4785 23.8048 17.2072 23.6924 17.0071 23.4923C16.807 23.2921 16.6946 23.0207 16.6946 22.7377C16.6946 22.4547 16.807 22.1832 17.0071 21.9831C17.2072 21.783 17.4785 21.6706 17.7615 21.6706H21.3178V16.3349C21.3178 16.0519 21.4302 15.7805 21.6302 15.5803C21.8303 15.3802 22.1017 15.2678 22.3846 15.2678Z",
    fill: "#FEA362"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_13982",
    x1: 17.9431,
    y1: -1.50098,
    x2: 44.4431,
    y2: 43.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006EC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00345C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_13982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.1917,
    height: 26.1917,
    fill: "white",
    transform: "translate(9.33618 9.48047)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_13982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(10.3362 10.4805)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLateIcon);
export default __webpack_public_path__ + "static/media/LateIcon.07de55d649746e2d117575c4e9d9cfb2.svg";
export { ForwardRef as ReactComponent };